import { format } from 'date-fns';
import { DATE_FORMAT_SHORT } from '../constants';

const getFormattedFields = (formData) => {
  const passportGiven = format(formData.passportGiven, DATE_FORMAT_SHORT);
  const passportValidUntil = formData.passportValidUntil
    ? format(formData.passportValidUntil, DATE_FORMAT_SHORT)
    : null;
  const birthday = format(formData.birthday, DATE_FORMAT_SHORT);
  const socCard = formData.socCard ? formData.socCard : null;
  return { passportGiven, passportValidUntil, birthday, socCard };
};

export default getFormattedFields;
